<template>
    <div>
        <div class="d-flex-center py-5">
            <img
                src="@/assets/report/daily.png">
        </div>
        <v-container>
            <v-row>
                <v-col
                    class="d-flex-center pb-0"
                    offset="4"
                    cols="4">
                        <div class="daily-report-input">
                            <v-menu
                                v-model="datePickerShow"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px">
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                            v-model="dateFormatted"
                                            :label="$vuetify.lang.t('$vuetify.daily.daily')"
                                            prepend-inner-icon="event"
                                            @click:prepend-inner="datePickerShow = true"
                                            readonly
                                            v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    :locale="localeLang"
                                    :min="minOfEndDate"
                                    :max="maxDate"
                                    v-model="datePick"
                                    @input="datePickerShow = false">
                                </v-date-picker>
                            </v-menu>
                        </div>
                </v-col>
                <v-col
                    class="d-flex-space-around pt-0"
                    offset="4"
                    cols="4">
                    <v-btn
                        color="red lighten-2"
                        class="ma-2 white--text"
                        width="180"
                        height="50"
                        :disabled="!canGenReport"
                        @click="submit()">
                        {{ $vuetify.lang.t('$vuetify.daily.exportPDF') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
export default {
    name: 'BranchOverviewReport',

    props: {
        canGenReport: {
            type: Boolean,
            default: false
        },
        branchId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            datePick: this.$util.getCurrentDate(),
            minDate: null,
            maxDate: this.$util.getCurrentDate(),
            exportPath: 'report/daily/pdf'
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        minOfEndDate () {
            const today = new Date()
            const oneWeekAgo = new Date(today)
            oneWeekAgo.setDate(today.getDate() - 7)
            return oneWeekAgo.toISOString().substr(0, 10)
        }
    },

    methods: {
        async submit () {
            const response = await this.axios.post('report/branch-overview/pdf', { date: this.datePick }, {
                headers: {
                    'Content-Type': 'application/pdf'
                },
                responseType: 'arraybuffer'
            })

            if (response && response.data) {
                this.$util.downloadPdfFile(response.data)

                this.$store.dispatch('setLoading', false)
            }
        }
    },

    watch: {
        'datePick' () {
            this.dateFormatted = this.$util.formatDate(this.datePick)
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
